<template>
  <button
    class="el-button"
    @click="handleClick($event)"
    :type="nativeType"
    :disabled="disabled"
    :class="[
      type ? 'el-button--' + type : '',
      {
        'is-disabled': disabled,
        'is-round': round
      }
    ]"
  >
    <slot></slot>
  </button>
</template>
<script>
export default {
  name: 'VButton',

  props: {
    type: {
      type: String,
      default: 'default'
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    disabled: Boolean,
    round: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    handleClick (evt) {
      this.$emit('click', evt);
    }
  }
};
</script>
<style lang="scss">
@import "../../assets/scss/var.scss";
.el-button {
  display: block;
  width: 100%;
  font-size: 1.6rem;
  color: #fff;
  background: $color-red;
  margin: auto;
  padding: 15px 0;
  border-radius: 3px;
  &.is-round {
    border-radius: 3rem;
  }
  &:active {
    background: $color-red-active;
  }
  &.is-disabled{
    background: $color-grey;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/base/button.vue